export class PackageType {
  constructor(
    public id: string,
    public name: string,
    public kind: PackageKind
  ) {}
}

export enum PackageKind {
  BUNDLE = 'BUN',
  EUR_PALETTE = 'EUR',
  CARDBOARD = 'CDB',
  BOX = 'BOX',
  BARELL = 'BAR',
  BAG = 'BAG',
  UNKNOWN = 'UNK',
}
